import styled from 'styled-components';
import { BasketSummaryDetailsStyled } from '../BasketSummaryDetailsStyled';
import { rem } from 'polished';

export const BasketSummaryDetailsAC = styled(BasketSummaryDetailsStyled)`
    background: ${({ theme }) => theme.colors.grey6};
    color: ${({ theme }) => theme.colors.grey5};

    .offerValidityDate {
        font-size: ${({ theme }) => theme.fontSizes.h4};
        color: ${({ theme }) => theme.colors.grey5};
    }

    .title {
        font-size: ${rem('16px')};
        background: none;
        color: ${({ theme }) => theme.colors.grey5};

        .label {
            svg {
                g {
                    path {
                        fill: ${({ theme }) => theme.colors.grey5} !important;
                    }
                }
            }
        }
    }

    .promoCodeSection {
        .promoCodeSectionWrapper {
            border-radius: ${rem(12)};
            background: ${({ theme }) => theme.colors.white};
            padding: ${rem('20px')};

            .promoCode__input {
                &:focus-visible {
                    outline: 3px solid ${({ theme }) => theme.colors.focus} !important;
                }
            }

            div {
                background: unset;

                button {
                    &:disabled {
                        border: 2px solid ${({ theme }) => theme.colors.grey3};
                        color: ${({ theme }) => theme.colors.grey3};
                        background-color: ${({ theme }) => theme.colors.white};
                    }
                }
            }
        }
    }

    .storePrice,
    .totalPrice,
    .promoCodeResult,
    .dealerDiscountResult,
    .priceSection,
    .ecoBonusWrapper_description {
        border-color: ${({ theme }) => theme.colors.grey3};

        .linkText {
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
    }

    .infoIcon {
        svg {
            g {
                circle {
                    fill: ${({ theme }) => theme.colors.grey2};
                    stroke: ${({ theme }) => theme.colors.grey2};
                }

                line {
                    stroke: ${({ theme }) => theme.colors.white};
                }
            }
        }
    }

    .storePrice {
        &_link {
            color: ${({ theme }) => theme.colors.grey5};
            font-size: ${({ theme }) => theme.fontSizes.h4};

            &:hover {
                color: ${({ theme }) => theme.colors.red};
            }
        }

        &_value {
            &_price {
                width: ${rem(175)};
                text-align: right;
            }
        }
    }

    .totalPrice {
        &_monthlyPrice {
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }
        &_cashPrice {
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }
        &_title {
            top: ${rem('24px')};
        }
        &_link {
            color: ${({ theme }) => theme.colors.grey5};
            font-size: ${({ theme }) => theme.fontSizes.h4};

            &:hover {
                color: ${({ theme }) => theme.colors.red};
            }
        }
        &_label {
            font-size: ${({ theme }) => theme.fontSizes.h6};
        }
    }

    .isShowPriceExcludedVAT-container {
        & > .totalPrice_cashPrice,
        & > .isShowPriceExcludedVAT {
            .formatMoney {
                font-size: ${rem('20px')};
            }
        }
    }

    .promoCodeSection {
        .promoCode {
            &__button {
                border-width: 2px;
                background: ${({ theme }) => theme.colors.white};
                font-size: ${({ theme }) => theme.fontSizes.h4};
                text-transform: capitalize;
                border: 2px solid ${({ theme }) => theme.colors.blue2};
                border-radius: ${rem(24)};
                color: ${({ theme }) => theme.colors.blue2};
                margin-left: ${rem(10)};

                &:hover:enabled {
                    color: ${({ theme }) => theme.colors.grey5};
                    background: ${({ theme }) => theme.colors.white};
                    border-color: ${({ theme }) => theme.colors.grey5};
                }
            }

            &__input {
                color: ${({ theme }) => theme.colors.grey1};
            }
        }

        &_title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
            color: ${({ theme }) => theme.colors.grey5};

            &:hover {
                color: ${({ theme }) => theme.colors.red};

                .isHide {
                    border-color: ${({ theme }) => theme.colors.red};
                }

                svg {
                    path {
                        stroke: ${({ theme }) => theme.colors.red};
                        stroke-width: 1;
                        fill: ${({ theme }) => theme.colors.red};
                    }
                }
            }

            .isHide {
                border-bottom: 1px solid ${({ theme }) => theme.colors.grey5};
            }

            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.grey5};
                    stroke-width: 1;
                    fill: ${({ theme }) => theme.colors.grey5};
                }
            }
        }

        input {
            border-radius: ${rem(12)};
        }
    }

    .pxSection {
        border-radius: ${rem(12)};

        &.withoutBackground {
            border-radius: 0;
        }

        &_title {
            font-size: ${({ theme }) => theme.fontSizes.h4};

            .link {
                font-size: ${({ theme }) => theme.fontSizes.h4};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.blue2};
                    }
                }
            }

            button {
                color: ${({ theme }) => theme.colors.grey5};

                &:hover {
                    color: ${({ theme }) => theme.colors.red};
                }
            }
        }

        &_status {
            &__label {
                font-size: ${({ theme }) => theme.fontSizes.h4};
                line-height: ${rem(24)};
            }
        }
    }

    .ecoBonusWrapper {
        svg {
            circle {
                stroke: ${({ theme }) => theme.colors.grey2};
                fill: ${({ theme }) => theme.colors.grey2};
            }

            line {
                stroke: ${({ theme }) => theme.colors.white};
            }
        }
    }

    .wallboxSection {
        border-radius: ${rem(12)};
        padding: ${rem(20)};

        &_title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
    }

    .continueSection {
        background: ${({ theme }) => theme.colors.grey6};
    }
`;
